module.exports = __webpack_public_path__ + "img/prime minister_share.6b111e50.jpg";